export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'ativa',
    caption: 'Ativa',
    width: 120,
    cellTemplate: 'SouNTemplate'
  },
  {
    dataField: 'tabela',
    caption: 'Descrição'
  },
  {
    dataField: 'fator_multiplicacao',
    caption: 'Fator Multiplicação',
    dataType: 'number'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
